import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ArrowHookUpLeftRegular, ArrowRightFilled } from '@fluentui/react-icons';
import BoardingStructure from '../../templates/BoardingStructure';
import {
  useId,
  Button,
  Toaster,
  MenuButton,
  Field,
  Input,
  Dropdown,
  Option,
  Switch,
  Label,
  Skeleton,
  SkeletonItem,
  makeStyles,
  tokens,
} from '@fluentui/react-components';

import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../../../authConfig';
import { getProvinceList, getDistrictList, getSubDistrictList } from '../../../../providers/AreaData';
const API_URL = process.env.REACT_APP_API_URL

const useStyles = makeStyles({
  invertedWrapper: {
    backgroundColor: tokens.colorNeutralBackground1,
    paddingTop: '50px',
    paddingBottom: '50px',
    width: '800px',
    minHeight: '500px'
  },

  invertedWrapperSecond: {
    backgroundColor: tokens.colorNeutralBackground1,
    paddingTop: '20px',
    paddingBottom: '20px',
    width: '800px',
    minHeight: '50px',
    marginTop: '50px'
  },
});



const CompanyForm = ({ setCurrentStep, handleUpdate }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const styles = useStyles();
  const DropdownErrMsg = t('addContact.dropdownErrMsg');
  const [branchBlankDisplay, setBranchBlankDisplay] = useState({
    key: '',
    text: '',
  });

  const location = useLocation();
  const data = location.state;
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const outlineId = useId('input-outline');
  const [language, setLanguage] = useState('th');

  const handleLanguageSwitch = () => {
    const nextLanguage = language === 'th' ? 'en' : 'th';
    setLanguage(nextLanguage);

    if (data?.branchNumber === '00000') {
      setTaxBranchNumberType('00000');
      handleBranch('00000', nextLanguage);
    } else {
      setTaxBranchNumberType('branchNumber');
      handleBranch(data?.branchNumber, nextLanguage);
    }
  };
  
  const [provinceList, setProvinceList] = useState([]);
  const [branchErrMsg, setBranchErrMsg] = useState('');
  const [name, setName] = useState('');
  const [buildingNumber, setBuildingNumber] = useState('');
  const [address, setAddress] = useState('');
  const [streetPrefix, setStreetPrefix] = useState('');
  const [streetName, setStreetName] = useState('');
  const [taxId, setTaxId] = useState('');
  const [branchNumber, setBranchNumber] = useState('00000');
  const [registerVat, setRegisterVat] = useState(false);
  const [province, setProvince] = useState({ key: '', text: '' });
  const [provinceKey, setProvinceKey] = useState(null);

  const taxBranchNumberTypeRef = useRef();
  const provinceRef = useRef();
  const districtRef = useRef();
  const subDistrictRef = useRef();

  const nameRef = useRef();
  const buildingNumberRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();
  const postCodeRef = useRef();

  const [taxBranchNumberType, setTaxBranchNumberType] = useState('');
  const [subDistrictPrefix, setSubDistrictPrefix] = useState('');
  const [districtPrefix, setDistrictPrefix] = useState('');
  const [provincePrefix, setProvincePrefix] = useState('');
  const [districtList, setDistrictList] = useState([]);
  const [district, setDistrict] = useState({ key: '', text: '' });
  const [subDistrictList, setSubDistrictList] = useState([]);
  const [subDistrict, setSubDistrict] = useState({ key: '', text: '' });
  const [postcode, setPostcode] = useState('');
  const [branchText, setBranchText] = useState('สำนักงานใหญ่');
  const [showBranchNumber, setShowBranchNumber] = useState(false);
  const [isSearchCompleate, setIsSearchCompleate] = useState(false);

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const streetPrefixSelect = [{ key: 'ถ.', text: 'ถ.' },
  { key: 'ถนน', text: 'ถนน' },
  { key: '', text: t('company.notDisplay') }]

  const provincePrefixSelect = [
    { key: 'จ.', text: 'จ.' },
    { key: 'จังหวัด', text: 'จังหวัด' },
    { key: '', text: t('company.notDisplay') }]

  const districtPrefixSelect = [
    { key: 'อ.', text: 'อ.' },
    { key: 'อำเภอ', text: 'อำเภอ' },
    { key: 'เขต', text: 'เขต' },
    { key: '', text: t('company.notDisplay') }
  ]

  const subDistrictPrefixSelect = [
    { key: 'ต.', text: 'ต.' },
    { key: 'ตำบล', text: 'ตำบล' },
    { key: 'แขวง', text: 'แขวง' },
    { key: '', text: t('company.notDisplay') }
  ]

  const registerVatSelect = [
    { key: true, text: t('company.registerVatYes') },
    { key: false, text: t('company.registerVatNo') },
  ]

  const getVatRegisterTextOfValue = (selectedValue) => {
      const foundOption = registerVatSelect.find(
        (documentoptions) => documentoptions.key === selectedValue
      );

      return foundOption ? foundOption.text : null;
  };


  const [branchDisplay, setBranchDisplay] = useState([
    { key: '00000', text: 'สำนักงานใหญ่' },
    { key: 'branchNumber', text: 'สาขาเลขที่' },
  ]);

  const BranchoptionsTh = [
    { key: '00000', text: 'สำนักงานใหญ่' },
    { key: 'branchNumber', text: 'สาขาเลขที่' },
  ];
  const BranchoptionsEn = [
    { key: '00000', text: 'Head office' },
    { key: 'branchNumber', text: 'Branch Number' },
  ];

  useEffect(() => {
    setProvinceList(getProvinceList(language));
  }, [language]);

  useEffect(() => {
    if (province.key) {
      const updatedText = getProvinceList(language).find(
        (p) => p.key === province.key
      )?.text;
      setProvince((prev) => ({ ...prev, text: updatedText || prev.text }));
    }
  }, [language, province.key]);

  useEffect(() => {
    const updatedDistrictList = getDistrictList(province.key, language);
    console.log('Updated District List:', updatedDistrictList);
    setDistrictList(updatedDistrictList);

  }, [language, province]);



  useEffect(() => {
    if (district.key) {
      const updatedText = getDistrictList(province.key, language).find(
        (d) => d.key === district.key
      )?.text;

      console.log('Updated District Text:', updatedText);

      setDistrict((prev) => ({ ...prev, text: updatedText || prev.text }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, district.key]);

  useEffect(() => {
    const updatedSubDistrictList = getSubDistrictList(district.key, language);
    console.log('Updated subDistrict List:', updatedSubDistrictList);
    setSubDistrictList(updatedSubDistrictList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, province]);



  useEffect(() => {
    if (subDistrict.key) {
      const updatedText = getSubDistrictList(district.key, language).find(
      (sd) => sd.key === subDistrict.key)?.text;
      console.log('sub district text', updatedText);
      setSubDistrict((prev) => ({ ...prev, text: updatedText || prev.text }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, subDistrict.key])



  useEffect(() => {
    if (provinceKey !== null) {
      setAreaPrefix(provinceKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceKey, language])



  useEffect(() => {
    if (branchBlankDisplay.key === '') {
      setBranchBlankDisplay([{ key: '00000', text: 'สำนักงานใหญ่' },
      { key: 'branchNumber', text: 'สาขาเลขที่' }]);
      setTaxBranchNumberType('00000');
      handleBranch('00000', language);
    }


    // eslint-disable-next-line
  }, [])


  const handleBranch = (branchNum, lang) => {

    if (lang === 'en') {
      setBranchDisplay([
        { key: '00000', text: 'Head office' },
        { key: 'branchNumber', text: 'Branch' },
      ]);
      console.log("work!! english dropdown")
    } else if (lang === 'th') {
      setBranchDisplay([
        { key: '00000', text: 'สำนักงานใหญ่' },
        { key: 'branchNumber', text: 'สาขาเลขที่' },
      ]);
      console.log("work!! Thai dropdown")
    }

    if (branchNum === '00000') {
      setShowBranchNumber(false);
      // setBranch('00000');
      setBranchNumber('00000');

      if (lang === 'en') {
        setBranchText('Head office');
      } else {
        setBranchText('สำนักงานใหญ่');
      }
    } else {
      if (branchNum !== '') {
        // setBranch('branchNumber');
        if (branchNum === 'branchNumber') {
          setBranchNumber('00000');

          if (lang === 'en') {
            setBranchText('Branch 00000');
          } else {
            setBranchText('สาขา 00000');
          }
        } else {
          setBranchNumber(branchNum);

          if (lang === 'en') {
            setBranchText('Branch ' + branchNum);
          } else {
            setBranchText('สาขา ' + branchNum);
          }
        }
        setShowBranchNumber(true);
      }
    }
  };


  const [showValidateProvince, setShowValidateProvince] = useState(false);
  const [showValidateDistrict, setShowValidateDistrict] = useState(false);
  const [showValidateSubDistrict, setShowValidateSubDistrict] = useState(false);
  const [showMessageBarSearchError, setShowMessageBarSearchError] =useState(false);
  const [showPleaseFill, setShowPleaseFill] =useState(false);
  const [showMessageBarNotFillFullLength, setShowMessageBarNotFillFullLength] =useState(false);
  const [showNameNotFill, setShowNameNotFill] =useState(false);
  const [showMessageNotFillBuildingNumber, setShowMessageNotFillBuildingNumber] = useState(false);
  const [showValidatePostCode, setShowValidatePostCode] = useState(false);

  const handlesetbuildingNumber = (e) => {
    setBuildingNumber(e.target.value);
  };

  const setBranchlength = (e) => {
    if (e.length <= 5) {
      setBranchNumber(e);
    }
  };

  const setPhonelength = (e) => {
    if (e.length <= 10) {
      setPhone(e);
    }
  };

  const getBranchTypeText = (selectedValue) => {
    if (language === 'th') {
      const foundOption = BranchoptionsTh.find(
        (documentoptions) => documentoptions.key === selectedValue
      );

      return foundOption ? foundOption.text : null;
    } else {
      const foundOption = BranchoptionsEn.find(
        (documentoptions) => documentoptions.key === selectedValue
      );
      return foundOption ? foundOption.text : null;
    }
  };


  const setAreaPrefix = (_provinceCode) => {
    if (_provinceCode === '10') {
      if (language === 'th') {
        setSubDistrictPrefix('แขวง');
        setDistrictPrefix('เขต');
        setProvincePrefix('');
        setStreetPrefix('ถ.');
      } else {
        setSubDistrictPrefix('');
        setDistrictPrefix('');
        setProvincePrefix('');
      }
    } else {
      if (language === 'en') {
        setSubDistrictPrefix('');
        setDistrictPrefix('');
        setProvincePrefix('');
      } else {
        setSubDistrictPrefix('ต.');
        setDistrictPrefix('อ.');
        setProvincePrefix('จ.');
        setStreetPrefix('ถ.');
      }
    }
  };


  useEffect(() => {
    if (data?.dataBack === true) {
      setIsSearchCompleate(true)
      if (data?.language === 'th') {
        setLanguage('th');

        if (data?.streetPrefix) {
          setStreetPrefix(data?.streetPrefix);
        }

        if (data?.provincePrefix) {
          setProvincePrefix(data?.provincePrefix);
        }

        if (data?.districtPrefix) {
          setDistrictPrefix(data?.districtPrefix);
        }

        if (data?.subDistrictPrefix) {
          setSubDistrictPrefix(data?.subDistrictPrefix);
        }
      } else {
        setLanguage('en');
      }

      setTaxId(data?.taxId);
      setName(data?.name);

      if (data?.branchNumber === '00000') {
        setTaxBranchNumberType('00000');
        handleBranch('00000', language);
      } else {
        setTaxBranchNumberType('branchNumber');
        handleBranch(data?.branchNumber, language);
      }

      setBuildingNumber(data?.buildingNumber);
      setAddress(data?.address);
      setStreetName(data?.streetName);
      setProvince(data?.province);
      setDistrict(data?.district);
      setSubDistrict(data?.subDistrict);
      setPostcode(data?.postcode);
      setPhone(data?.phone);
      setEmail(data?.email);
      setRegisterVat(data?.registerVat);
    }
    // eslint-disable-next-line
  }, [])

  const getฺProvinceNull = (name) => {
    if (!name) {
      return t('addContact.pleaseSelectaProvince');
    };
    return '';
  };

  const toasterId = useId('toaster');
  const [isLoading, setIsLoading] = useState(false);
  const [showMessagePhoneWarn, setShowMessagePhoneWarn] = useState(false);
  const [showMessageEmailWarn, setShowMessageEmailWarn] = useState(false);

  function handleSearch() {
    handleUpdate('/boarding/companySearch', true, 'CompanyForm')
    setShowNameNotFill(false);
    setShowMessageNotFillBuildingNumber(false);
    setShowValidatePostCode(false);
    setShowMessagePhoneWarn(false);
    setShowMessageEmailWarn(false);
    setName('');
    setBuildingNumber('');
    setAddress('');
    setStreetPrefix('');
    setStreetName('');
    setRegisterVat(false);
    setProvince({ key: '', text: '' });
    setProvinceKey(null);
    setSubDistrictPrefix('');
    setSubDistrict({ key: '', text: '' });
    setDistrictPrefix('');
    setDistrict({ key: '', text: '' });
    setProvincePrefix('');
    setPostcode('');
    setPhone('');
    setEmail('');

    if (taxId.length === 13) {
      setIsLoading(true);
      setShowMessageBarSearchError(false);
      handleUpdate('/boarding/companySearchTaxid', taxId, 'CompanyForm')
      handleUpdate('/boarding/companySearchBranchNumber', branchNumber, 'CompanyForm')
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          axios
            .get(API_URL + '/sources/rd/vat/' + taxId + (branchNumber ? `?branch=${branchNumber}` : ''), {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
                'Content-Type': 'application/json',
              },
              timeout: 10000
            })
            .then((response) => {
              console.log('response from rd vat', response);
              if (!response.data.msgerr[0]) {
                setRegisterVat(true);

                if (response.data.BranchNumber[0] === 0) {
                  if (language === 'th') {
                    setBranchText('สำนักงานใหญ่');
                  } else {
                    setBranchText('Head office');
                  }
                  setBranchNumber('00000');
                } else if (response.data.BranchNumber[0] !== '-') {
                  if (language === 'th') {
                    setBranchText('สาขา ' + String(response.data.BranchNumber[0]).padStart(5, '0'));
                  } else {
                    setBranchText('Branch ' + String(response.data.BranchNumber[0]).padStart(5, '0'));
                  }
                  setBranchNumber(String(response.data.BranchNumber[0]).padStart(5, '0'));
                }

                let _branchTitleName = response.data.BranchTitleName[0].trim();
                if (response.data.BranchTitleName[0].trim() === '-') {
                  _branchTitleName = response.data.TitleName[0]
                }

                setName(_branchTitleName + ' ' + response.data.Name[0].trim().substring(0, 140));
                setBuildingNumber(response.data.HouseNumber[0].trim().substring(0, 16));

                let _address = '';

                if (response.data.BuildingName[0].trim() !== '-') {
                  _address = _address + response.data.BuildingName[0].trim() + ' ';
                }

                if (response.data.FloorNumber[0].trim() !== '-') {
                  _address = _address + 'ชั้น ' + response.data.FloorNumber[0].trim() + ' ';
                }

                if (response.data.RoomNumber[0].trim() !== '-') {
                  _address = _address + 'ห้อง ' + response.data.RoomNumber[0].trim() + ' ';
                }

                if (response.data.MooNumber[0].trim() !== '-') {
                  _address = _address + 'หมู่ ' + response.data.MooNumber[0].trim() + ' ';
                }

                if (response.data.SoiName[0].trim() !== '-') {
                  _address = _address + 'ซอย ' + response.data.SoiName[0].trim() + ' ';
                }

                if (response.data.VillageName[0].trim() !== '-') {
                  _address = _address + 'หมู่บ้าน ' + response.data.VillageName[0].trim() + ' ';
                }
                setAddress(_address.trim().substring(0, 256));

                setStreetPrefix(response.data.StreetName[0].trim() !== '-' ? 'ถ.' : '');
                setStreetName(response.data.StreetName[0].trim() !== '-' ? response.data.StreetName[0].trim().substring(0, 70) : '');

                provinceList.forEach((province) => {
                  if (province.text === (response.data.Province[0]).trim()) {
                    setProvince({
                      key: province.key,
                      text: province.text,
                    });

                    if (province.key === '10') {
                      setSubDistrictPrefix('แขวง');
                      setDistrictPrefix('เขต');
                      setProvincePrefix('');
                    } else if (province.key) {
                      setSubDistrictPrefix('ต.');
                      setDistrictPrefix('อ.');
                      setProvincePrefix('จ.');
                    } else {
                      setSubDistrictPrefix('');
                      setDistrictPrefix('');
                      setProvincePrefix('');
                    }

                    let districtList = getDistrictList(province.key, language);

                    setDistrictList(districtList);
                    districtList.forEach((district) => {
                      if (district.text === (response.data.Amphur[0]).trim()) {
                        setDistrict({
                          key: district.key,
                          text: district.text,
                        });

                        let subDistrictList = getSubDistrictList(district.key, language);
                        setSubDistrictList(subDistrictList);
                        subDistrictList.forEach((subDistrict) => {
                          if (subDistrict.text === (response.data.Thambol[0]).trim()) {
                            setSubDistrict({
                              key: subDistrict.key,
                              text: subDistrict.text,
                            });
                          }
                        });
                      }
                    });
                  }
                });
                setPostcode(response.data.PostCode[0].trim().substring(0, 16));
                setIsSearchCompleate(true);
                setShowMessageBarNotFillFullLength(false);
                setShowPleaseFill(false);
                setIsLoading(false);
                setShowValidateProvince(false);
                setShowValidateDistrict(false);
                setShowValidateSubDistrict(false);
                handleUpdate('/boarding/companySearchFound', true, 'CompanyForm')
              } else {
                setIsSearchCompleate(true);
                setShowMessageBarNotFillFullLength(false);
                setShowPleaseFill(false);
                setIsLoading(false);
                console.log('ไม่พบข้อมูล');

              }
            }).catch((err) => {
              if (axios.isCancel(err)) {
                console.log('Request timed out');
                setIsSearchCompleate(true);
                setShowMessageBarNotFillFullLength(false);
                setShowPleaseFill(false);
              } else {
                console.error('Error:', err);
                setIsSearchCompleate(true);
                setShowMessageBarNotFillFullLength(false);
                setShowPleaseFill(false);
                setIsLoading(false);
              }
            })
        })

        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
        });

    } else if (taxId.length !== 13) {
      setShowMessageBarNotFillFullLength(true);
    }


  }


  useEffect(() => {

    if (language === 'en') {
      setSubDistrictPrefix('ไม่แสดง');
      setDistrictPrefix('ไม่แสดง');
      setProvincePrefix('ไม่แสดง');
      setStreetPrefix('ไม่แสดง');
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);


  const handleSubmit = (e) => {

    e.preventDefault();
    handleUpdate('/boarding/companySearchTaxid', taxId, 'CompanyForm')
    handleUpdate('/boarding/companySearchBranchNumber', branchNumber, 'CompanyForm')
    let isCorrect = true;

    if (name.length === 0) {
      nameRef.current?.focus();
    }

    if (buildingNumber.length === 0) {
      buildingNumber.current?.focus();
    }

    if (address.length > 256){
      address.current?.focus()
    }

    if (phone.length === 0) {
      phoneRef.current?.focus();
    }

    if (email.length === 0) {
      emailRef.current?.focus();
    }

    if (postcode.length === 0) {
      postCodeRef.current?.focus();
    }

    let branchTextResult;
    if (branchText === 'สาขา 00000' || branchText === 'Branch 00000') {
      if (language === 'th') {
        branchTextResult = 'สำนักงานใหญ่';
      } else {
        branchTextResult = 'Head office';
      }
    } else {
      branchTextResult = branchText;
    }


    let streetPrefixResult = streetPrefix;
    if (streetPrefix === 'ไม่แสดง') {
      streetPrefixResult = '';
    }
    let provincePrefixResult = provincePrefix;
    if (provincePrefix === 'ไม่แสดง') {
      provincePrefixResult = '';
    }

    let districtPrefixResult = districtPrefix;
    if (districtPrefix === 'ไม่แสดง') {
      districtPrefixResult = '';
    }

    let subDistrictPrefixResult = subDistrictPrefix;
    if (subDistrictPrefix === 'ไม่แสดง') {
      subDistrictPrefixResult = '';
    }


    if (taxId.length !== 13) {
      isCorrect = false;
      setShowPleaseFill(true);

    }

    if (name === '') {
      isCorrect = false;
      setShowNameNotFill(true);
    }

    if (buildingNumber === '') {
      isCorrect = false;
      setShowMessageNotFillBuildingNumber(true);
    }



    if (province.key === '') {
      isCorrect = false;
      provinceRef.current?.focus();
      provinceRef.current?.blur();
      setShowValidateProvince(true);
    }
    if (district.key === '') {
      isCorrect = false;
      districtRef.current?.focus();
      districtRef.current?.blur();
      setShowValidateDistrict(true);
    }

    if (subDistrict.key === '') {
      isCorrect = false;

      subDistrictRef.current?.focus();
      subDistrictRef.current?.blur();
      setShowValidateSubDistrict(true);
    }

    if (
      province.key === undefined ||
      province.key === null ||
      province.key === ''
    ) {
      isCorrect = false;
    }

    if (
      district.key === undefined ||
      district.key === null ||
      district.key === ''
    ) {
      isCorrect = false;
    }

    if (
      subDistrict.key === undefined ||
      subDistrict.key === null ||
      subDistrict.key === ''
    ) {
      isCorrect = false;
    }

    let _branchNumber = branchNumber;
    if (taxId === '0000000000000' || Number(taxId) === 0) {
      isCorrect = false;
    }

    if (postcode) {
      if (isNaN(postcode)) {
        isCorrect = false;
        setShowValidatePostCode(true);
      }

      if (postcode.length !== 5) {
        isCorrect = false;
        setShowValidatePostCode(true);
      }
    }

    if (name.length > 140) {
      isCorrect = false;
    }

    if (buildingNumber.length > 16) {
      isCorrect = false;
    }

    if (address.length > 256) {
      isCorrect = false;
    }

    if (streetName.length > 70) {
      isCorrect = false;
    }

    if (postcode.length > 16) {
      isCorrect = false;
    }

    if (taxId.length > 35) {
      isCorrect = false;
    }

    if (_branchNumber.length > 5) {
      isCorrect = false;
    }

    if (phone.length > 35) {
      isCorrect = false;
    }

    if (email.length > 256) {
      isCorrect = false;
    }
    if (postcode === '') {
      isCorrect = false;
      setShowValidatePostCode(true);
    }

    setShowMessagePhoneWarn(false)
    if (phone.length < 10) {
      isCorrect = false;
      setShowMessagePhoneWarn(true);
    }

    if (email === '') {
      isCorrect = false;
      setShowMessageEmailWarn(true);
    }

    if (isCorrect) {
      setCurrentStep(5);
      handleUpdate('/boarding/lastestStep', 2, 'CompanyForm')
      handleUpdate('/boarding/lastestSubStep', 2, 'CompanyForm')

      history.push({
        pathname: '/boarding/company/preview',
        state: {
          templates: data.templates,
          companyLogo: data?.companyLogo,
          companySignature: data?.companySignature,
          taxId: taxId,
          branchNumber: branchNumber,
          branchText: branchTextResult,
          name: name,
          buildingNumber: buildingNumber,
          address: address,
          streetPrefix: streetPrefixResult,
          streetName: streetName,
          provincePrefix: provincePrefixResult,
          province: province,
          districtPrefix: districtPrefixResult,
          district: district,
          subDistrictPrefix: subDistrictPrefixResult,
          subDistrict: subDistrict,
          postcode: postcode,
          phone: phone,
          email: email,
          registerVat: registerVat,
          language: language,
        },
      });
    }
  }

  return (
    <BoardingStructure>
      <Toaster toasterId={toasterId} />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div style={{
          marginTop: "17px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "30px",
              marginBottom: "17px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MenuButton
              formTarget="my-form"
              form="my-form"
              type="submit"
              appearance="primary"
              menuIcon={null} icon={<ArrowRightFilled />}
              onClick={(e)=>{
                handleUpdate("/boarding/companyPreviewButtonClick", true, "CompanyForm")
                handleSubmit(e)}}
              style={{ marginRight: "10%" }}
            >
              {t('boarding.next')}
            </MenuButton>
            <MenuButton
              appearance="secendary"
              style={{ alignSelf: "center", }}
              icon={<ArrowHookUpLeftRegular />}
              menuIcon={null}
              onClick={() => {
                setCurrentStep(3)
                handleUpdate("/boarding/lastestStep", 1, "CompanyForm")
                handleUpdate("/boarding/lastestSubStep", 3, "CompanyForm")
                history.push({
                  pathname: "/boarding/templates/preview",
                  state: {
                    templates: data.templates,
                    companyLogo: data?.companyLogo,
                    companySignature: data?.companySignature
                  },
                });
              }}

            >
              {t('boarding.back')}
            </MenuButton>
          </div>
        </div>
      </div>

      <form id="my-form" onSubmit={handleSubmit}
        style={{
          width: "800px",
          display: "flex",
          flexDirection: "column",
          minHeight: "170px",
          marginBottom: "2%",
          backgroundColor: "white"
        }}>
        <div style={{ display: "flex", justifyContent: "space-between", }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", margin: "20px", marginTop: "20px", fontWeight: "bold", fontSize: "30px", marginBottom: "20px", }}>
            <Label>{t("boarding.pleaseFillTaxId")}</Label>
          </div>
          <div style={{ display: "flex", flexDirection: "row-reverse", width: "400px", margin: "20px", marginLeft: "0px", marginTop: "20px", fontSize: "30px", marginBottom: "0px", marginRight: "20px" }}>
            <Label>
              <Switch
                label={t("boarding.englishAddressInformation")}
                onClick={handleLanguageSwitch}
                labelPosition="before"
                checked={language === "en" ? true : false}
              />
              {language === "en" ? t("boarding.open") : t("boarding.off")}</Label>
          </div>
        </div>



        <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", height: "70px", alignContent: "center", margin: "20px", marginBottom: "0px", marginTop: "0px" }}>
          <Field
            label={
              <Label
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  alignSelf: "left",
                  marginBottom: "0px",
                }}
              >
                {t('company.taxId')}
              </Label>
            }
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              width: "40%",
            }}
            size="medium"
            validationMessageIcon=""
            validationState={showMessageBarNotFillFullLength || showMessageBarSearchError || showPleaseFill ? "error" : "none"}
            validationMessage={showMessageBarNotFillFullLength ? t('boarding.pleaseEnterThirteenDigitNumber') : showPleaseFill ? t('boarding.pleaseEnterTaxID') : ""}
          >
            <Input
              appearance="outline"
              name="taxId"
              type="text"
              size="medium"
              min-width="25%"
              maxLength={13}
              value={taxId}
              onChange={(e) => {
                if (!isNaN(e.target.value)) {
                  console.log('Tax id lenght: ', e.target.value);
                  setTaxId(e.target.value);
                }
              }}
              ref={nameRef}
              onBlur={() => {
                if (taxId === "") {
                  setShowPleaseFill(true);
                } else {
                  setShowPleaseFill(false);
                  setShowMessageBarNotFillFullLength(false);
                  setShowMessageBarSearchError(false);
                }
              }}
            >
            </Input>
          </Field>
          <Field
            label={
              <Label
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  alignSelf: "left",
                  marginLeft: "10px",
                }}
              >
                {t('company.branchDisplay')}
              </Label>
            }
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              width: "25%",
            }}
            size="medium"
          >
            <Dropdown
              key={language}
              placeholder={t("addContact.pleaseSelect")}
              appearance="outline"
              required
              ref={taxBranchNumberTypeRef}
              onBlur={() => {
                if (branchBlankDisplay.key === "") {
                  setBranchErrMsg(DropdownErrMsg);
                } else {
                  setBranchErrMsg("");
                }
              }}
              value={getBranchTypeText(taxBranchNumberType)}
              errorMessage={branchErrMsg}
              style={{ marginLeft: "10px", minWidth: "25%" }}
              onOptionSelect={(_, data) => {
                console.log("databranchType", data);
                setBranchBlankDisplay(data.optionText);
                setTaxBranchNumberType(data.optionValue.key);
                handleBranch(data.optionValue.key, language);

              }}
            >
              {branchDisplay.map((option) => (
                <Option
                  key={option.key}
                  text={option.text}
                  value={option}
                >
                  {option.text}
                </Option>
              ))}
            </Dropdown>
          </Field>
          {showBranchNumber &&
            <Field
              label={
                <Label
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    alignSelf: "left",
                    marginLeft: "10px"
                  }}
                >
                  {t('company.branchNumber')}
                </Label>
              }
              style={{
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                width: "15%",
              }}
              size="medium"
            >
              <Input
                appearance="outline"
                size="medium"
                min-width="50%"
                style={{ marginLeft: "10px" }}
                value={branchNumber}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) {
                    setBranchlength(e.target.value);
                    if (language === "en") {
                      setBranchText("Branch " + e.target.value);
                    } else {
                      setBranchText("สาขา " + e.target.value);
                    }
                  }
                }}
              >
              </Input>
            </Field>
          }
          <Field
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              width: "15%",
              alignContent: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
            size="medium"
          >
            <Button appearance="primary" style={{ marginTop: "15px" }} onClick={() => handleSearch()}>{t('boarding.search')}</Button>
          </Field>
        </div>
      </form>
      {
        isLoading ?
          <>
            <div className={styles.invertedWrapper} >
              <div style={{ width: "100%" }}>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>
              <div style={{ width: "100%", display: "flex", marginTop: "60px" }}>
                <Skeleton aria-label="Loading Content" style={{ marginTop: "20px", marginLeft: "20px", width: "30%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", width: "70%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>
              <div style={{ width: "100%", display: "flex" }}>
                <Skeleton aria-label="Loading Content" style={{ marginTop: "20px", marginLeft: "20px", width: "30%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", width: "70%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>
              <div style={{ width: "100%", display: "flex" }}>
                <Skeleton aria-label="Loading Content" style={{ marginTop: "20px", marginLeft: "20px", width: "30%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", width: "70%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>
              <div style={{ width: "100%", display: "flex" }}>
                <Skeleton aria-label="Loading Content" style={{ marginTop: "20px", marginLeft: "20px", width: "30%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", width: "70%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>
              <div style={{ width: "100%", display: "flex" }}>
                <Skeleton aria-label="Loading Content" style={{ marginTop: "20px", marginLeft: "20px", width: "30%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", width: "70%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>
              <div style={{ width: "100%", display: "flex", marginBottom: "0px" }}>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", width: "28%", marginBottom: "0px" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>

            </div>
            <div className={styles.invertedWrapperSecond} >
              <div style={{ width: "100%", display: "flex" }}>
                <Skeleton aria-label="Loading Content" style={{ marginTop: "20px", marginLeft: "20px", width: "50%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", width: "50%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>
            </div>
            <div className={styles.invertedWrapperSecond} >
              <div style={{ width: "100%" }}>
                <Skeleton aria-label="Loading Content" style={{ margin: "20px", width: "47%" }} >
                  <SkeletonItem style={{ height: "30px" }} />
                </Skeleton>
              </div>

            </div>
          </>
          : <form form="my-form" onSubmit={handleSubmit} >
            {
              isSearchCompleate &&
              <div style={{ width: "800px", display: "flex", flexDirection: "column", backgroundColor: "white", minHeight: "500px", marginTop: "1%", marginBottom: "2%", background: "white" }}>

                {/* Company Name Input */}
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "20px", marginTop: "20px" }}>
                  <Field
                    label={
                      <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>
                        {t('company.name')}
                      </Label>
                    }
                    style={{ display: "flex", flexDirection: "column", width: "100%" }}
                    size="medium"
                    validationMessageIcon=""
                    validationMessage={showNameNotFill ? t('boarding.pleaseEnterCompanyName') : ""}
                    required
                  >
                    <Input
                      appearance="outline"
                      id={outlineId}
                      maxLength={140}
                      name="name"
                      type="text"
                      size="medium"
                      value={name}
                      style={{ width: "100%" }}
                      onChange={(e) => setName(e.target.value)}
                      onBlur={() => {
                        if (name === "") {
                          setShowNameNotFill(true);
                        } else {
                          setShowNameNotFill(false);
                        }
                      }}
                    />
                  </Field>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px", margin: "20px", marginBottom: "0px", fontWeight: "bold", fontSize: "30px", marginTop: "0px" }}>
                  <Label> {t('boarding.addressDetails')}</Label>
                </div>
                {/* Address Fields */}
                <div style={{ display: "flex", flexDirection: "column", gap: "20px", margin: "20px", marginTop: "20px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginTop: "0px" }}>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>
                          {t('company.buildingNumber')}
                        </Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "30%" }}
                      size="medium"
                      validationMessageIcon=""
                      validationState={showMessageNotFillBuildingNumber ? "error" : ""}
                      validationMessage={showMessageNotFillBuildingNumber ? t('boarding.pleaseEnterHouseNumber') : ""}
                      required
                    >
                      <Input
                        appearance="outline"
                        id={outlineId}
                        name="subDistrict"
                        type="text"
                        size="medium"
                        style={{ width: "100%" }}
                        maxLength={16}
                        value={buildingNumber}
                        onChange={(e) => handlesetbuildingNumber(e)}
                        required
                        onBlur={() => {
                          if (buildingNumber === "") {
                            setShowMessageNotFillBuildingNumber(true);
                          } else {
                            setShowMessageNotFillBuildingNumber(false);
                          }
                        }}
                        ref={buildingNumberRef}
                      />
                    </Field>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px", marginTop: "0px" }}>
                          {t('company.address')}
                        </Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "70%" }}
                      size="medium"
                      validationState={address.length > 256? "error" : ""}
                      validationMessage={address.length > 256 ?  t('boarding.tooLongAddress') : ""}
                    >
                      <Input
                        appearance="outline"
                        id={outlineId}
                        name="address"
                        type="text"
                        size="medium"
                        style={{ width: "100%" }}
                        maxLength={256}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </Field>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginTop: "0px" }}>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>
                          {t('company.streetPrefix')}
                        </Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "30%" }}
                      size="medium"
                    >
                      <Dropdown
                        placeholder={t("addContact.pleaseSelect")} style={{ minWidth: "unset", width: "220px", }}
                        value={streetPrefix}
                        onOptionSelect={(_, data) => {
                          console.log("data street Prefix", data);
                          setStreetPrefix(data.optionText);
                        }}

                      >
                        {streetPrefixSelect.map((option) => (
                          <Option
                            key={option.key}
                            text={option.text}
                            value={option}
                          >
                            {option.text}
                          </Option>
                        ))}
                      </Dropdown>
                    </Field>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px", marginTop: "0px" }}>
                          {t('company.streetName')}
                        </Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "70%" }}
                      size="medium"
                      validationState={streetName.length > 70 ? "error" : ""}
                      validationMessage={streetName.length > 70 ? t('boarding.tooLongStreetName') : ""}
                    >
                      <Input
                        appearance="outline"
                        id={outlineId}
                        name="district"
                        type="text"
                        size="medium"
                        maxLength={70}
                        style={{ width: "100%" }}
                        placeholder=""
                        value={streetName}
                        onChange={(e) => setStreetName(e.target.value)}
                      />
                    </Field>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginTop: "0px" }}>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>
                          {t('company.provincePrefix')}
                        </Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "30%" }}
                      size="medium"
                    >
                      <Dropdown
                        placeholder={t("addContact.pleaseSelect")}
                        style={{ minWidth: "unset", width: "220px", }}
                        value={provincePrefix}
                        onOptionSelect={(_, data) => {
                          console.log("data province", data);
                          setProvincePrefix(data.optionText);
                        }}
                      >
                        {provincePrefixSelect.map((option) => (
                          <Option
                            key={option.key}
                            text={option.text}
                            value={option}
                          >
                            {option.text}
                          </Option>
                        ))}
                      </Dropdown>
                    </Field>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>{t('company.province')}</Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "70%", justifyContent: "center" }}
                      validationMessageIcon=""
                      validationState={showValidateProvince ? "error" : ""}
                      validationMessage={showValidateProvince ? t('boarding.pleaseSelectProvince') : ""}
                    >
                      <Dropdown
                        key={language}
                        placeholder={t("addContact.pleaseSelect")}
                        onOptionSelect={(_, data) => {
                          console.log("data", data);
                          setProvince(data.optionValue);
                          setAreaPrefix(data.optionValue.key);
                          setProvinceKey(data.optionValue.key);
                          setDistrict({ key: "", text: "" });
                          setDistrictList(
                            getDistrictList(data.optionValue.key, language)
                          );
                          setSubDistrict({ key: "", text: "" });
                          setShowValidateProvince(false);

                        }}
                        appearance="outline"
                        name="province"
                        required
                        style={{ minWidth: "25%" }}
                        label={t("addContact.province")}
                        value={province.text}
                        ref={provinceRef}
                        validationMessageIcon="error"
                        validationMessage={getฺProvinceNull(province.key)}
                      >
                        {provinceList.map((option) => (
                          <Option value={option} key={option.key}>
                            {option.text}
                          </Option>
                        ))}
                      </Dropdown>

                    </Field>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginTop: "0px" }}>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>
                          {t('company.districtPrefix')}
                        </Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "30%" }}
                      size="medium"
                    >
                      <Dropdown
                        placeholder={t('company.pleaseSelect')} style={{ minWidth: "unset", width: "220px", }}
                        value={districtPrefix}
                        onOptionSelect={(_, data) => {
                          setDistrictPrefix(data.optionText);
                        }}
                      >
                        {districtPrefixSelect.map((option) => (
                          <Option
                            key={option.key}
                            text={option.text}
                            value={option}
                          >
                            {option.text}
                          </Option>
                        ))}
                      </Dropdown>
                    </Field>
                    <Field
                      label={
                        <Label>
                          {t("addContact.district")}
                        </Label>
                      }
                      style={{
                        textAlign: "left",
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                      size="large"
                      validationMessageIcon=""
                      validationState={showValidateDistrict ? "error" : ""}
                      validationMessage={
                        showValidateDistrict
                          ? t('boarding.pleaseSelectDistrict')
                          : ""
                      }
                    >
                      <Dropdown
                        key={language}
                        placeholder={t("addContact.pleaseSelect")}
                        onOptionSelect={(_, data) => {
                          console.log("data", data);
                          setDistrict(data.optionValue);
                          setSubDistrict({ key: "", text: "" });
                          setSubDistrictList(getSubDistrictList(data.optionValue.key, language));
                          setShowValidateDistrict(false);
                        }}
                        appearance="outline"
                        required
                        style={{ minWidth: "25%" }}
                        size="medium"
                        label={t("addContact.district")}
                        value={district.text}
                      >
                        {districtList.map((option) => (
                          <Option value={option} key={option.key}>
                            {option.text}
                          </Option>
                        ))}
                      </Dropdown>

                    </Field>{" "}
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginTop: "0px" }}>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>
                          {t('company.subDistrictPrefix')}
                        </Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "30%" }}
                      size="medium"
                    >
                      <Dropdown
                        placeholder={t('company.pleaseSelect')}
                        style={{ minWidth: "unset", width: "220px", }}
                        value={subDistrictPrefix}
                        onOptionSelect={(_, data) => {
                          setSubDistrictPrefix(data.optionText);
                          }}
                      >
                        {subDistrictPrefixSelect.map((option) => (
                          <Option
                            key={option.key}
                            text={option.text}
                            value={option}
                          >
                            {option.text}
                          </Option>
                        ))}

                      </Dropdown>
                    </Field>
                    <Field
                      label={<Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>{t('company.subDistrict')}</Label>}
                      style={{ display: "flex", flexDirection: "column", width: "70%", justifyContent: "center" }}
                      size="medium"
                      validationMessageIcon=""
                      validationState={showValidateSubDistrict ? "error" : ""}
                      validationMessage={showValidateSubDistrict ? t('boarding.pleaseSelectSubdistrict') : ""}
                    >
                      <Dropdown
                        key={language}
                        placeholder={t("addContact.pleaseSelect")}
                        onOptionSelect={(_, data) => {
                          setSubDistrict(data.optionValue);
                          setShowValidateSubDistrict(false);
                        }}
                        appearance="outline"
                        style={{ minWidth: "25%" }}
                        required

                        label={t("addContact.subDistrict")}
                        value={subDistrict.text}
                        ref={subDistrictRef}
                        onBlur={(e) => {
                          if (district.key !== "" && subDistrict.key === "") {
                            setShowValidateSubDistrict(true);
                          } else {
                            setShowValidateSubDistrict(false);
                          }
                        }}

                      >
                        {subDistrictList.map((option) => (
                          <Option
                            key={option.key}
                            value={option}
                            text={option.text}
                          >
                            {option.text}
                          </Option>
                        ))}

                      </Dropdown>
                    </Field>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginTop: "0px" }}>
                    <Field
                      label={
                        <Label style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "5px" }}>
                          {t('company.postcode')}
                        </Label>
                      }
                      style={{ display: "flex", flexDirection: "column", width: "30%" }}
                      size="medium"
                      validationMessageIcon=""
                      validationState={showValidatePostCode ? "error" : ""}
                      validationMessage={showValidatePostCode ? t('boarding.pleaseEnterFiveDigitNumber') : ""}
                      required
                    >
                      <Input
                        appearance="outline"
                        id={outlineId}
                        name="postcode"
                        type="text"
                        size="medium"
                        style={{ width: "100%" }}
                        maxLength={16}
                        value={postcode}
                        onChange={(e) => {
                          if (!e.target.value.includes(' ') && !isNaN(e.target.value)) {
                            setPostcode(e.target.value);
                          }
                        }}
                        onBlur={() => {
                          if (postcode === "") {
                            setShowValidatePostCode(true);
                          } else {
                            setShowValidatePostCode(false);
                          }
                        }}
                        ref={postCodeRef}
                      />
                    </Field>
                  </div>
                </div>

              </div >
            }

            {
              isSearchCompleate &&
              <div style={{ width: "800px", display: "flex", flexDirection: "column", backgroundColor: "white", minHeight: "150px", marginTop: "2%", marginBottom: "2%" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px", margin: "20px", marginTop: "20px", marginBottom: "0px", fontWeight: "bold", fontSize: "30px" }}>
                  <Label>{t('company.contactForCustomer')}</Label>
                </div>

                <div style={{ width: "100%", display: "flex", height: "70px", alignContent: "center", margin: "20px", marginBottom: "0px", marginTop: "20px", }}>
                  <Field
                    label={
                      <Label
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          alignSelf: "left",
                          marginBottom: "0px",
                        }}
                      >
                        {t('company.phone')}
                      </Label>
                    }
                    style={{
                      textAlign: "left",
                      display: "flex",
                      flexDirection: "column",
                      width: "47%",
                      marginRight: "1%"
                    }}
                    size="medium"
                    validationMessageIcon=""
                    validationState={showMessagePhoneWarn ? "error" : "none"}
                    validationMessage={showMessagePhoneWarn ? t('boarding.pleaseProvideInformation') : ""}
                    required
                  >
                    <Input
                      appearance="outline"
                      id={outlineId}
                      name="postcode"
                      type="text"
                      size="medium"
                      maxLength={10}
                      min-width="100%"
                      value={phone}
                      onChange={(e) => setPhonelength(e.target.value)}
                      required
                      onBlur={() => {
                        if (phone === "") {
                          setShowMessagePhoneWarn(true);
                        } else {
                          setShowMessagePhoneWarn(false);
                        }
                      }}
                      ref={phoneRef}
                    >
                    </Input>
                  </Field>

                  <Field
                    label={
                      <Label
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          alignSelf: "left",
                          marginLeft: "0px"
                        }}
                      >
                        {t('company.email')}
                      </Label>
                    }
                    style={{
                      textAlign: "left",
                      display: "flex",
                      flexDirection: "column",
                      width: "47%",

                    }}
                    size="medium"
                    validationMessageIcon=""
                    validationState={showMessageEmailWarn ? "error" : "none"}
                    validationMessage={showMessageEmailWarn ? t('boarding.pleaseProvideInformation') : ""}
                    required
                  >
                    <Input
                      appearance="outline"
                      id={outlineId}
                      name="email"
                      type="email"
                      size="medium"
                      min-width="100%"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      validateOnLoad={false}
                      validateOnFocusOut
                      onBlur={() => {
                        if (email === "") {
                          setShowMessageEmailWarn(true);
                        } else {
                          setShowMessageEmailWarn(false);
                        }
                      }}
                      ref={emailRef}
                    >
                    </Input>
                  </Field>
                </div>
              </div>
            }
            {
              isSearchCompleate &&
              <div style={{ width: "800px", display: "flex", flexDirection: "column", backgroundColor: "white", minHeight: "100px", marginTop: "2%", marginBottom: "2%" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", height: "70px", alignContent: "center", margin: "20px", marginTop: "20px" }}>
                  <Field
                    label={
                      <Label

                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          alignSelf: "left",
                          marginBottom: "0px",
                        }}
                      >
                        {t('company.registerVat')}
                      </Label>
                    }
                    style={{
                      textAlign: "left",
                      display: "flex",
                      flexDirection: "column",
                      width: "47%",
                    }}
                    size="medium"
                  >
                    <Dropdown
                      placeholder={t('company.pleaseSelect')}
                      onOptionSelect={(_, data) => {
                        console.log("data", data.optionValue.key);
                        setRegisterVat(data.optionValue.key);
                        handleBranch('00000', language);
                      }}
                      value={getVatRegisterTextOfValue(registerVat)}
                    >
                      {registerVatSelect.map((option) => (
                        <Option
                          key={option.key}
                          value={option}
                          text={option.text}
                        >
                          {option.text}
                        </Option>
                      ))}
                    </Dropdown>
                  </Field>

                </div>
              </div>
            }
          </form>
      }

    </BoardingStructure >

  );
};

export default CompanyForm;
